// extracted by mini-css-extract-plugin
export var measureBox = "_cd-0";